import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from './shared/lib/queryClient';
import ScrollToTop from './shared/components/ScrollToTop';
import { AuthProvider } from './shared/context/AuthContext';
import { PlatformFeaturesProvider } from './shared/context/PlatformFeaturesContext';
import { ToastProvider } from './shared/ui';
import { RouteErrorBoundary } from './shared/components/common/RouteErrorBoundary';
import { AppRoutes } from './app/routes/AppRoutes';
import './shared/ui/ui.css';
import './App.css';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <PlatformFeaturesProvider>
          <ToastProvider>
            <Router>
              <ScrollToTop />
              <RouteErrorBoundary fullscreen>
                <AppRoutes />
              </RouteErrorBoundary>
            </Router>
          </ToastProvider>
        </PlatformFeaturesProvider>
      </AuthProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
